import { styled, Typography } from '@mui/material';
import { Box } from '@mui/system';

export const AccessDeniedContainerStyled = styled(Box)({
  maxHeight: '80vh',
  display: 'flex',
  flexDirection: 'column',
});

export const AccessDeniedImageStyled = styled('img')({
  maxWidth: '70%',
  maxHeight: '30%',
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',
});

export const AdminLoginNoticeTypographyStyled = styled(Typography)({
  width: '80%',
  justifyContent: 'center',
  alignSelf: 'center',
  textAlign: 'center',
  textTransform: 'none',
});

export const InfoNoticeTypographyStyled = styled(Typography)({
  width: '80%',
  justifyContent: 'center',
  alignSelf: 'center',
  textAlign: 'center',
  fontWeight: 500,
});

export const ButtonContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '2.4rem',
  maxHeight: '20%',
});

export const LogoContainerStyled = styled(Box)({
  display: 'flex',
  height: '7rem',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 0px 3px 3px lightgray',
  marginBottom: '2.4rem',
});
